import { LoadingMessage } from './LoadingMessage.component';

export default LoadingMessage;
